export type SelectedFiltersMap = Map<string, Set<string>>;

export const getSelectedFilters = (
	groupKeys: Array<string>,
	segments: Array<string>,
) => {
	const selectedFilters: SelectedFiltersMap = new Map();
	let currentGroupKey: string | undefined;

	for (const groupKey of groupKeys) {
		selectedFilters.set(groupKey, new Set());
	}

	for (const segment of segments) {
		if (groupKeys.includes(segment)) {
			currentGroupKey = segment;
			continue;
		}

		if (currentGroupKey && segment) {
			selectedFilters.get(currentGroupKey)?.add(segment);
		}
	}

	return selectedFilters;
};
